import update from 'immutability-helper';
import FreeWriteBuilderModalEnum from './FreeWriteBuilderModalConstants';

const initialState = {
  isDocumentReadyModalOpen: false,
  isEraserModalOpen: false,
  isHighlighterModalOpen: false,
  isRedactModalOpen: false,
};

const setClosedState = (state, action) => {
  switch (action.modalType) {
    case FreeWriteBuilderModalEnum.DOCUMENT_READY_FREEWRITE_MODAL:
      return update(state, {
        isDocumentReadyModalOpen: { $set: false },
      });
    case FreeWriteBuilderModalEnum.ERASER_FREEWRITE_MODAL:
      return update(state, {
        isEraserModalOpen: { $set: false },
      });
    case FreeWriteBuilderModalEnum.HIGHLIGHTER_FREEWRITE_MODAL:
      return update(state, {
        isHighlighterModalOpen: { $set: false },
      });
    case FreeWriteBuilderModalEnum.REDACT_FREEWRITE_MODAL:
      return update(state, {
        isRedactModalOpen: { $set: false },
      });
    default:
      return state;
  }
};
const setOpenState = (state, action) => {
  switch (action.modalType) {
    case FreeWriteBuilderModalEnum.DOCUMENT_READY_FREEWRITE_MODAL:
      return update(state, {
        isDocumentReadyModalOpen: { $set: true },
      });
    case FreeWriteBuilderModalEnum.ERASER_FREEWRITE_MODAL:
      return update(state, {
        isEraserModalOpen: { $set: true },
      });
    case FreeWriteBuilderModalEnum.HIGHLIGHTER_FREEWRITE_MODAL:
      return update(state, {
        isHighlighterModalOpen: { $set: true },
      });
    case FreeWriteBuilderModalEnum.REDACT_FREEWRITE_MODAL:
      return update(state, {
        isRedactModalOpen: { $set: true },
      });
    default:
      return state;
  }
};

const FreeWriteBuilderModalHandler = (state = initialState, action) => {
  switch (action.type) {
    case FreeWriteBuilderModalEnum.FREEWRITE_MODAL_CLOSE:
      return setClosedState(state, action);
    case FreeWriteBuilderModalEnum.FREEWRITE_MODAL_OPEN:
      return setOpenState(state, action);
    default:
      return state;
  }
};

export default FreeWriteBuilderModalHandler;



// WEBPACK FOOTER //
// ./src-react/FreeWriteBuilderModals/FreeWriteBuilderModalReducer.jsx